export const OnboardingScreen2Helper = {
    header: 'Ok, let’s get started.',
    subHeader: 'First, let’s make sure your info is correct. The data you see here was provided by your employer. Take a look and update anything that doesn’t look right.',
    title: 'Basic Info',
}